import { render, staticRenderFns } from "./AddSportPricekinetic.vue?vue&type=template&id=5f1ddd39&scoped=true&"
import script from "./AddSportPricekinetic.vue?vue&type=script&lang=js&"
export * from "./AddSportPricekinetic.vue?vue&type=script&lang=js&"
import style0 from "./AddSportPricekinetic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddSportPricekinetic.vue?vue&type=style&index=1&id=5f1ddd39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ddd39",
  null
  
)

export default component.exports